import type { CustomerType } from '@/enums';

import { useUserProfile } from '@/hooks/useUsers';
import isEmpty from 'lodash/isEmpty';
import { Navigate } from 'react-router';

export default function RoleGuard({
  children,
  role,
  redirect,
  rootAdmin,
}: Readonly<{
  children: React.ReactNode;
  role: CustomerType | CustomerType[];
  redirect?: string;
  rootAdmin?: boolean;
}>) {
  const { organizationCustomerType, parentOrganizationCode } = useUserProfile();
  const allowedRoles = Array.isArray(role) ? role : [role];

  if (
    !allowedRoles.includes(organizationCustomerType) ||
    (rootAdmin && !isEmpty(parentOrganizationCode))
  ) {
    return redirect ? <Navigate to={redirect} /> : null;
  }

  return <>{children}</>;
}
